import { EMPTY_OBJECT } from '../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { SIZE } from '../../../constants/size'
import { FormModal } from '../../Form'

import { FormFields } from './FormFields'
import { QA_NAME_EDIT_PRIORITY_MODAL } from './TaskEditPriorityModal.constants'
import {
  getTaskEditPriorityActionTypes,
  getTaskEditPriorityPayload,
  getTaskEditPriorityValidationSchema,
} from './TaskEditPriorityModal.utils'

function TaskEditPriorityModal({
  formFieldsProps: {
    actionTypes = getTaskEditPriorityActionTypes(),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  getPayload = getTaskEditPriorityPayload,
  getValidationSchema = getTaskEditPriorityValidationSchema,
  initialValues,
  onSubmit,
  ...restProps
}) {
  const validationSchema = getValidationSchema()

  function handleSubmit({ values }) {
    onSubmit({
      payload: getPayload(values),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_EDIT_PRIORITY_MODAL,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Task.EditPriorityModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default TaskEditPriorityModal
